import { separatorsForLocale } from './separators-for-locale.js';
export const toNumber = (input, locale) => {
    if (typeof input !== 'string') {
        return input;
    }
    const { group, decimal } = separatorsForLocale(locale);
    return Number(input.replace(decimal, '.').replace(group, '_'));
};
